module.exports = __webpack_public_path__ + "img/product_110.ed0729c.webp";